import { Component, Input }         from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

import { BigDecimalService }    from '../../../core/services/big-decimal.service';
import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  selector   : 'wor-counter-control',
  styles: [ require('./counter-control.component.scss') ],
  template: require('./counter-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class CounterControlComponent extends TextControlComponent {
  @Input() max ?: number | string;
  @Input() min = 0;

  _round: number;
  _step : number | string;

  @Input() set round ( _round : number | string ) {
    this._round = _round && this.bigDecimalService.isNumber(_round) && +_round >= 0
      ? +_round
      : 0;
  }

  @Input() set step ( _step : number | string ) {
    this._step = _step
      ? this.bigDecimalService.get(_step, this._round).toString()
      : 1;
  }

  constructor (
    private bigDecimalService: BigDecimalService
  ) {
    super();
  }

  onStepClick ( direction = 'up' ) : void {
    const limit = direction === 'down'
      ? this.min
      : this.max;

    const roundedLimit = direction === 'down'
      ? this.bigDecimalService.get(this.min, this._round)
      : this.bigDecimalService.get(this.max, this._round);

    const step = this.bigDecimalService.get(this._step, this._round);

    let model = this.bigDecimalService.get(this._model, this._round);

    const next = direction === 'down'
      ? model.subtract(step)
      : model.add(step);

    model = ( limit !== undefined && limit !== null )
      && ( ( direction === 'down' && ( model <= roundedLimit || next <= roundedLimit ) )
      || ( direction === 'up' && ( model >= roundedLimit || next >= roundedLimit ) ) )
        ? roundedLimit
        : next;

    this._model = this.bigDecimalService.get(model, this._round).toString();

    this.modelChange.emit(this._model);
  }
}
